import { ILink } from '../../interface/page/link.interface';

export function formLinkFromTemplate(linkTemplate: ILink, linkerId: string): ILink {
  return Object.assign({}, linkTemplate, {linkerId});
}
